// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useState } from 'react'
import { Arr } from '../../../helpers/Arr'
import { IElementProps, IOrderOption } from '../../../types/interfaces'
import { ObjectHelper } from '../../../helpers/ObjectHelper'
import { useTranslation } from 'react-i18next'
const FuelSelect = (props: IElementProps) => {
  const { t } = useTranslation('common')
  const [optionsToRender, setoptionsToRender] = useState<IOrderOption[]>(null)

  useEffect(() => {
    const optionsToRenderRaw: IOrderOption[] = Arr.any(props.options)
      ? props.options
      : !!props.externalData?.data
      ? Object.keys(props.externalData.data).map((key) => ({
          name: props.externalData.data[key],
          value: key,
        }))
      : []
    if (Arr.any(optionsToRenderRaw)) {
      const options = ObjectHelper.clone(optionsToRenderRaw)
      options.sort((a, b) => a.name.localeCompare(b.name))
      const noneOption = options.splice(
        options.findIndex((el) => el.value === 'none'),
        1
      )
      if (Arr.any(noneOption)) {
        options.push(noneOption[0])
      }
      setoptionsToRender(options)
    }
  }, [props.options, props.externalData?.data])

  const optionSelect = (name, e) => {
    const z = defineValue(e.target.value)
    const ev = {
      target: {
        value: z,
      },
    } as React.ChangeEvent<HTMLInputElement>
    props.handleChange(name, ev)
    const fuelSelect: any = document.getElementById('fuelSelect')
    fuelSelect.selectedIndex = 0
  }
  const deleteIcon = (name, cardName) => {
    const newValue = props.value
      .split(',')
      .filter((v) => v !== cardName)
      .join(',')
    const e = {
      target: {
        value: newValue === '' ? null : newValue,
      },
    } as React.ChangeEvent<HTMLInputElement>
    props.handleChange(props.name, e)
  }

  function defineValue(selectedValue: string) {
    if (selectedValue === 'na') {
      return selectedValue
    }
    if (props.value) {
      if (selectedFuelCards?.includes('na')) {
        return selectedValue
      } else {
        return props.value + ',' + selectedValue
      }
    }
    if (!props.value) {
      return selectedValue
    }
  }

  // useEffect(() => {
  //   if (props.defaultValue && !props.value) {
  //     const e = {
  //       target: {
  //         value: props.defaultValue,
  //       },
  //     } as React.ChangeEvent<HTMLInputElement>

  //     optionSelect(props.name, e)
  //   }
  // }, [])

  const { fuelCardsLimit } = props
  const hasOptions = Arr.any(props.options)
  const selectedFuelCards = props.value?.split(',') || []
  return (
    <>
      {props.visible && (
        <div className="formGroup">
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>
              {props.label} (max {fuelCardsLimit})
            </label>
          </div>
          <div className="selectArea selectfuelCard required-highlight">
            <select
              id="fuelSelect"
              onChange={(e) => optionSelect(props.name, e)}
              defaultValue={selectedFuelCards?.includes('na') ? props.value : ''}
              disabled={
                props.formReadOnly ||
                props.disabledInput ||
                (fuelCardsLimit > 0 && selectedFuelCards.length >= fuelCardsLimit)
              }
            >
              <option selected disabled value={''} />
              {optionsToRender?.length > 0 &&
                optionsToRender
                  .filter((option) =>
                    props.value && option.value !== 'na' ? props.value.indexOf(option.value) < 0 : true
                  )
                  .map((option, i) => (
                    <option value={option.value} key={i}>
                      {t(option.name)}{' '}
                    </option>
                  ))}
            </select>
            <i className="icon-bottom" />
          </div>
          {props.value && !selectedFuelCards.includes('na') ? (
            <div className="flex">
              {selectedFuelCards.map((el) => (
                <div
                  style={
                    !hasOptions && props.externalData?.misc?.[el]?.toLowerCase().includes('electric')
                      ? { border: '1px solid #253979', color: '#253979', display: 'table' }
                      : { display: 'table' }
                  }
                  className={`fuelCard ${
                    !hasOptions && props.externalData?.misc?.[el]?.toLowerCase().includes('electric') && 'electric'
                  }`}
                >
                  <div className="table-cell">
                    <div className="brandsArea">
                      {el !== 'none' && (
                        <img
                          className="locImg"
                          src={`/${el.toLowerCase().indexOf('international') >= 0 ? 'international' : 'national'}.svg`}
                        />
                      )}{' '}
                      {el === 'none' ? (
                        <i className="icon-fuelcard-no" />
                      ) : (
                        el.split('-').map((q) => <img src={`/${q.toLowerCase().split(' ')[0]}.svg`} />)
                      )}{' '}
                    </div>
                    <div className="cardFeatures">
                      {!hasOptions && props.externalData?.misc?.[el]?.toLowerCase().includes('electric') && (
                        <i className="icon-fuelcard-electric" />
                      )}
                      {!hasOptions && props.externalData?.misc?.[el]?.toLowerCase().includes('carwash') && (
                        <i className="icon-car-wash" />
                      )}
                    </div>
                    {!props.formReadOnly && !props.disabledInput && (
                      <i className="icon-close" onClick={(e) => deleteIcon(props.name, el)} />
                    )}
                    <div
                      style={
                        !hasOptions && props.externalData?.misc?.[el]?.toLowerCase().includes('electric')
                          ? { background: '#253979', color: '#F1CD2E' }
                          : {}
                      }
                      className={`fuelBrand ${el === 'none' && 'noFuelCard'}`}
                    >
                      {el}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      )}
    </>
  )
}
export default FuelSelect
